export default "__VITE_ASSET__BNnk2rGX__"